import PropTypes from 'prop-types';
import React from 'react';

import { LabelWrapper } from './styled';

const Label = ({ description, required, label, id }) => {
  return (
    <LabelWrapper>
      {label && (
        <label htmlFor={id}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}

      {description && (
        typeof description === 'string' ? (
          <p
            dangerouslySetInnerHTML={{ __html: renderToString(description) }}
            className="description"
          />
        ) : description
      )}
    </LabelWrapper> 
  )
};

Label.defaultProps = {
  description: '',
  required: false,
  label: '',
  id: ''
};

Label.propTypes = {
  description: PropTypes.node,
  required: PropTypes.bool,
  label: PropTypes.node,
  id: PropTypes.string,
};

export default Label;